import React, { ReactNode } from 'react';
import styles from '../../../../styles/PerformanceDashboard.module.css';
import CustomDropdown, { DropdownOption } from '../../../UI/CustomDropdown';

interface ChartCardProps {
  title: string;
  subtitle: string;
  children: ReactNode;
  selector?: {
    value: string;
    onChange: (value: string) => void;
    options: DropdownOption[];
  };
}

const ChartCard: React.FC<ChartCardProps> = ({ title, subtitle, children, selector }) => {
  return (
    <div className={styles.chartCard}>
      <div className={styles.chartHeader}>
        <div className={styles.chartHeaderTop}>
          <div>
            <h3 className={styles.chartTitle}>{title}</h3>
            <p className={styles.chartSubtitle}>{subtitle}</p>
          </div>
          {selector && (
            <CustomDropdown
              options={selector.options}
              value={selector.value}
              onChange={(value) => {
                if (typeof value === 'string') {
                  selector.onChange(value);
                }
              }}
              placeholder="Select comparison"
              size="sm"
              variant="outlined"
              className={styles.chartSelector}
            />
          )}
        </div>
      </div>
      <div className={styles.chartContainer}>
        {children}
      </div>
    </div>
  );
};

export default ChartCard;

